import { GetterTree } from 'vuex';
import { SkillProfState, RootState } from './learner-types';

const getters: GetterTree<SkillProfState, RootState> = { skillName: (state) => state.skillprof?.skillName, profName: (state) => state.skillprof?.ProfName, learnerData: (state) => state.skillprof?.learnerData };

export default getters;
